export enum MapTool {
  ZoomIn = "zoom-in",
  ZoomOut = "zoom-out",
  Rotate = "rotate",
  TogglePitch = "toggle-pitch",
}
